import { render, staticRenderFns } from "./LessonsPage.vue?vue&type=template&id=2601eb4c&lang=pug&"
import script from "./LessonsPage.vue?vue&type=script&lang=js&"
export * from "./LessonsPage.vue?vue&type=script&lang=js&"
import style0 from "./LessonsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports